import { Box, Card, Typography, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Tabs, Tab, InputAdornment, Button } from '@mui/material';
import LayoutAccessManagement from 'components/structure/LayoutAccessManagement';
import { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import crossIcon from 'assets/user-access/crossblue.svg'
import dragIcon from 'assets/user-access/drag-icon.svg'
import iconSearchs from 'assets/user-access/searchIcon.svg'
import rightArrow from 'assets/user-access/rightarrow-blue.svg'
import bottomArrow from 'assets/user-access/downarrow-blue.svg'
import editPencil from 'assets/user-access/editPencil.svg'
import { useLocation, useNavigate } from 'react-router-dom';
import CustomBlueCheckbox from 'utils/CustomBlueCheckbox';
// {
//     "statusCode": 201,
//     "message": "Success",
//     "response": {
//         "role-id": "0a2a910c-922e-196f-8192-2eac6afd0000",
//         "role-name": "Role_Test_004",
//         "role-owner": "Local Admin",
//         "modules": [
//             {
//                 "module-role-link-id": "0a2a8e0f-9290-1ce4-8192-91888a020000",
//                 "module-id": "bd9b11b3-3a7d-4e22-819f-6ba5cd7d3d12",
//                 "module-name": "Manage Operations",
//                 "is-create": false,
//                 "is-update": false,
//                 "is-delete": false,
//                 "is-read": false,
//                 "functionalities": [
//                     {
//                         "functionality-role-id": null,
//                         "functionality-id": "c05dffa5-2381-497c-8f31-67b02f7911b9",
//                         "functionality-name": "Season Registration",
//                         "is-create": false,
//                         "is-update": false,
//                         "is-delete": false,
//                         "is-read": false,
//                         "is-active": false
//                     },
//                     {
//                         "functionality-role-id": null,
//                         "functionality-id": "c50cfe0d-6216-430d-ba58-6c07651fb492",
//                         "functionality-name": "Module Registration",
//                         "is-create": false,
//                         "is-update": false,
//                         "is-delete": false,
//                         "is-read": false,
//                         "is-active": false
//                     },
//                     {
//                         "functionality-role-id": null,
//                         "functionality-id": "63d43a00-22f8-4339-97d3-7dde6307b3cf",
//                         "functionality-name": "Crop Stage Registration",
//                         "is-create": false,
//                         "is-update": false,
//                         "is-delete": false,
//                         "is-read": false,
//                         "is-active": false
//                     },
//                     {
//                         "functionality-role-id": null,
//                         "functionality-id": "cac2dc27-9fe4-4565-b72d-7fd97b29496d",
//                         "functionality-name": "Crop Stage Calendar",
//                         "is-create": false,
//                         "is-update": false,
//                         "is-delete": false,
//                         "is-read": false,
//                         "is-active": false
//                     },
//                     {
//                         "functionality-role-id": null,
//                         "functionality-id": "86f48434-2dca-4590-9cd1-9e6f0b034966",
//                         "functionality-name": "Hierarchy Configuration",
//                         "is-create": false,
//                         "is-update": false,
//                         "is-delete": false,
//                         "is-read": false,
//                         "is-active": false
//                     },
//                     {
//                         "functionality-role-id": null,
//                         "functionality-id": "0ea9c7b9-9195-49a8-b50a-b74c852ee22f",
//                         "functionality-name": "Questionnaire Setup",
//                         "is-create": false,
//                         "is-update": false,
//                         "is-delete": false,
//                         "is-read": false,
//                         "is-active": false
//                     }
//                 ]
//             },
//             {
//                 "module-role-link-id": "0a2a8e0f-9290-1ce4-8192-91917ce70002",
//                 "module-id": "39fbeebc-f955-4971-b303-d32cddb0fb47",
//                 "module-name": "Module1",
//                 "is-create": false,
//                 "is-update": false,
//                 "is-delete": false,
//                 "is-read": false,
//                 "functionalities": null
//             }
//         ]
//     }
// }
const RoleAssign = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { rowData } = location.state || {};
    const [data, setdata] = useState([])
    const columns = [
        { id: 'module', label: 'Module' },
        { id: 'create', label: 'Create' },
        { id: 'read', label: 'Read' },
        { id: 'update', label: 'Update' },
        { id: 'delete', label: 'Delete' },
        { id: 'all', label: 'All' },
        { id: 'flf', label: 'Field Level Filter' },
    ];

    // const [data, setdata] = useState(
    //     [{
    //         modules: {id:1, moduleName: 'Contracting', is-create: false, is-update: true, canUpdate: true, is-delete: true },
    //         subModules: [
    //             {id:1, moduleName: 'Farmer Registration', is-create: true, is-update: false, canUpdate: true, is-delete: true },
    //             { id:2, moduleName: 'Survey', is-create: false, is-update: true, canUpdate: true, is-delete: false }

    //         ],
    //     },

    //     {
    //         modules: {id:1, moduleName: 'Only Reports', is-create: false, is-update: true, canUpdate: true, is-delete: true },
    //         subModules: [
    //             // { moduleName: 'Test1', is-create: true, is-update: true, canUpdate: true, is-delete: true },
    //             // { moduleName: 'Test1', is-create: true, is-update: true, canUpdate: true, is-delete: true }

    //         ],
    //     }],

    // )







    const VerticalLine = () => {
        return (
            < Box
                sx={{
                    width: '100%',
                    height: '2px',
                    backgroundColor: '#0E2B63',
                    opacity: 0.2,
                    margin: '0 auto'
                }}
            />
        );
    };
    const handleToggle = (id, field, value) => {
        // const params = new URLSearchParams();
        // params.append(field, value)
        // setLoading(true)
        // QuestionnareService.updateByCheckbox({ data: { [field]: value }, questionId: id, modifiedByUser: user ? user?.userName : "" }).then((res) => {
        //   setLoading(false)
        //   let data = res?.data?.statusCode;
        //   if (data == 200) {
        //     let mId = selectedModuleId;
        //     if (mId == "" || mId == undefined) {
        //       mId = modules[0]?.moduleId
        //     }
        //     FetchSubModules(selectedCropYear, mId)
        //     setMessage("Saved Successfully");
        //     setOpenAlert(true);
        //     setSeverity("success");
        //   }
        // }).catch((ex) => {
        //   console.log('error', ex)
        //   setLoading(false)
        //   setMessage("Update Failed");
        //   setOpenAlert(true);
        //   setSeverity("error");
        // })
    };

    const onEdit = (row) => {
        navigate('/roleAssign/editmodule/' + row?.modules?.id)
    }
    return (
        <LayoutAccessManagement title="Access Management">
            <Card
                className='Access-Management-Layout'
                sx={{
                    backgroundColor: "#f3f5f8",
                    color: "white",
                    marginBottom: "30px",
                    padding: "20px",
                    border: "none",
                    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    justifyContent: "center"
                }}
            >
                <Box sx={{ width: "948px", marginTop: "40px", marginBottom: "40px", borderRadius: '16px', backgroundColor: "#fff", height: "auto" }}>
                    <Box className="roleAssignHeader">
                        Survey Approver
                    </Box>
                    <VerticalLine />
                    <Box className="roleAssignHeader2" sx={{ fontWeight: 700, padding: '23px 0px 20px 0px' }}>
                        Role Owner
                        <Box className="roleAssignHeader2" sx={{ fontWeight: 500 }}>Local ESG Admin</Box>
                    </Box>
                    <VerticalLine />
                    <Box className="roleAssignHeader2" sx={{ fontWeight: 700, padding: '20px 0px 17px 0px' }}>Assigned Functionality</Box>
                    <Box className="roleAssignTable">
                        <TableContainer component={Paper} sx={{ overflow: 'unset !important' }}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#102A63' }}>
                                    <TableRow>
                                        {columns?.map((column, index) => (
                                            <TableCell
                                                sx={{ color: '#fff', borderRight: '1px solid #ddd', textAlign: "center" }}
                                                key={column.id}>
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data?.map((row, ind) => (
                                        <>
                                            <TableRow key={ind}>
                                                <TableCell sx={{
                                                    borderRight: '1px solid #ddd',
                                                    wordBreak: 'break-word',
                                                    overflowWrap: 'break-word',
                                                    maxWidth: 300,
                                                    minWidth: 200,
                                                }}><Box className="roleAssignTableModule">{row?.modules?.moduleName}</Box></TableCell>
                                                <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                    <CustomBlueCheckbox
                                                        checked={row?.modules['is-create']}
                                                        onClick={() => handleToggle(row?.modules['is-create'], 'module')}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                    <CustomBlueCheckbox
                                                        checked={row?.modules['is-create']}
                                                        onClick={() => handleToggle(row?.modules['is-create'], 'module')}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                    <CustomBlueCheckbox
                                                        checked={row?.modules['is-create']}
                                                        onClick={() => handleToggle(row?.modules['is-create'], 'module')}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                    <CustomBlueCheckbox
                                                        checked={row?.modules['is-create']}
                                                        onClick={() => handleToggle(row?.modules['is-create'], 'module')}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                    <CustomBlueCheckbox
                                                        checked={row?.modules['is-create']}
                                                        onClick={() => handleToggle(row?.modules['is-create'], 'module')}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                    <img style={{ cursor: "pointer" }} src={editPencil}
                                                        onClick={() => onEdit(row, 'module')}
                                                    />
                                                    {/* <CustomBlueCheckbox
                                                        checked={row?.modules['is-create']}
                                                        onClick={() => handleToggle(row?.modules['is-create'], 'module')}
                                                    /> */}
                                                </TableCell>

                                            </TableRow>
                                            {row?.subModules.map((subRow, i) => {
                                                return <TableRow key={i} sx={{ backgroundColor: "#F5F5F7" }}>
                                                    {/* {JSON.stringify(subRow)} */}
                                                    <TableCell sx={{
                                                        borderRight: '1px solid #ddd',
                                                        wordBreak: 'break-word',
                                                        overflowWrap: 'break-word',
                                                        maxWidth: 300,
                                                        minWidth: 200,
                                                    }}><Box className="roleAssignTableSubModule" sx={{ paddingLeft: "20px" }}> {subRow?.moduleName}</Box></TableCell>
                                                    <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                        <CustomBlueCheckbox
                                                            checked={subRow['is-create']}
                                                            onClick={() => handleToggle(subRow['is-create'], 'module')}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                        <CustomBlueCheckbox
                                                            checked={subRow['is-create']}
                                                            onClick={() => handleToggle(subRow['is-create'], 'module')}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                        <CustomBlueCheckbox
                                                            checked={subRow['is-create']}
                                                            onClick={() => handleToggle(subRow['is-create'], 'module')}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                        <CustomBlueCheckbox
                                                            checked={subRow['is-create']}
                                                            onClick={() => handleToggle(subRow['is-create'], 'module')}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                        <CustomBlueCheckbox
                                                            checked={subRow['is-create']}
                                                            onClick={() => handleToggle(subRow['is-create'], 'module')}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                        <img style={{ cursor: "pointer" }} src={editPencil}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            })}

                                        </>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box sx={{ paddingTop: "30px" }}>
                        <VerticalLine />
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "cemter", margin: "40px 10px" }}>
                        <Button
                            sx={{
                                justifyContent: "center",
                                borderRadius: 4,
                                minWidth: 130,
                                minHeight: 54,
                                background: "#737D86",
                                marginLeft: "20px",
                                "&:hover": {
                                    backgroundColor: "#737D86",
                                },
                            }}
                            variant="contained"
                            type="button"
                            onClick={(e) => navigate(-1)}
                        >
                            {"BACK"}
                        </Button>
                        <Button
                            sx={{
                                justifyContent: "center",
                                borderRadius: 4,
                                minWidth: 156,
                                minHeight: 54,
                                background: "#112A63",
                                marginLeft: "20px",
                                "&:hover": {
                                    backgroundColor: "#112A63",
                                },
                            }}
                            variant="contained"
                            type="button"
                            onClick={(e) => navigate('/roleAssign')}
                        >
                            {"UPDATE"}
                        </Button>
                    </Box>
                </Box>
            </Card>
        </LayoutAccessManagement >
    );
};

export default RoleAssign;
